/**
 * Frontend interactions for Featured Collections block.
 *
 * Uses document-level delegation so clicks still work when WooCommerce Cart
 * remounts empty-cart InnerBlocks after Store API loading (common for guests).
 */
const BLOCK_SELECTOR = '.wp-block-mdny-blocks-featured-collections';
const TAB_SELECTOR = '.cc-featured-collections__tab';
const PANEL_SELECTOR = '.cc-featured-collections__panel';
const SEE_MORE_SELECTOR = '.cc-featured-collections__see-more';
const HIDDEN_PRODUCT_SELECTOR =
	'.cc-featured-collections__product--hidden-mobile';

const activateTab = ( block, tabButton ) => {
	const tabId = tabButton.getAttribute( 'data-tab-id' );

	if ( ! tabId ) {
		return;
	}

	block.querySelectorAll( TAB_SELECTOR ).forEach( ( item ) => {
		const isActive = item === tabButton;
		item.classList.toggle(
			'cc-featured-collections__tab--active',
			isActive
		);
		item.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
	} );

	block.querySelectorAll( PANEL_SELECTOR ).forEach( ( panel ) => {
		const isActive = panel.getAttribute( 'data-tab-id' ) === tabId;
		panel.classList.toggle(
			'cc-featured-collections__panel--active',
			isActive
		);
		panel.hidden = ! isActive;
	} );
};

const revealHiddenProducts = ( button ) => {
	const panel = button.closest( PANEL_SELECTOR );

	if ( ! panel ) {
		return;
	}

	panel.querySelectorAll( HIDDEN_PRODUCT_SELECTOR ).forEach( ( product ) => {
		product.classList.remove(
			'cc-featured-collections__product--hidden-mobile',
			'cc-product-card--hidden-mobile'
		);
	} );

	button.hidden = true;
};

document.addEventListener( 'click', ( event ) => {
	const target = event.target;

	if ( ! ( target instanceof Element ) ) {
		return;
	}

	const seeMoreButton = target.closest( SEE_MORE_SELECTOR );

	if ( seeMoreButton ) {
		revealHiddenProducts( seeMoreButton );
		return;
	}

	const tabButton = target.closest( TAB_SELECTOR );

	if ( ! tabButton ) {
		return;
	}

	const block = tabButton.closest( BLOCK_SELECTOR );

	if ( ! block ) {
		return;
	}

	activateTab( block, tabButton );
} );
